<template>
  <!--图文说明-->
  <div class="graphic-instructions" v-if="baseInfo">
    <banner wzades="一件事主题服务优势" aria-label="一件事主题服务优势" outBannerHeight="350px" :bannerAttachPath="baseInfo.pictureModePath" :defaultBanner="bannerPic">
      <div class="banner-title">
        <span class="title">{{ baseInfo.typeName }}</span>
        <span class="tag">集成服务</span>
        <div class="banner-subtitle" v-if="baseInfo.serviceInfo">
          <div class="subtitle">现只需跑动 <span class="em">{{ baseInfo.serviceInfo.runNumsAfter }}</span> 次, 提交 <span class="em">{{ baseInfo.serviceInfo.stuffNumsAfter }}</span> 份材料,<span class="em">{{ baseInfo.serviceInfo.handleLimitAfter }}</span> 天完成审批,<span class="em">{{ resultMaterialsLength }}</span> 份结果</div>
          <div class="subtitle">让您少跑 <span class="em">{{ baseInfo.serviceInfo.runNumsBefore - baseInfo.serviceInfo.runNumsAfter }}</span> 次, 少交 <span class="em">{{ baseInfo.serviceInfo.stuffNumsBefore - baseInfo.serviceInfo.stuffNumsAfter }}</span>  份材料, 审批时间缩减 <span class="em">{{ baseInfo.serviceInfo.handleLimitBefore - baseInfo.serviceInfo.handleLimitAfter }}</span> 天</div>
        </div>

        <div style="margin-top: 40px;">
          <el-button type="primary" class="common-button" @click="handleNow" v-if="baseInfo.isOnlineApply == 1">
            立即办理<i class="el-icon-d-arrow-right el-icon--right"></i>
          </el-button>
          <el-button class="common-button-white" @click="goBack">
            返回上一页
          </el-button>
        </div>

      </div>
    </banner>

    <div class="graphic-steps" wzades="一件事主题服务办理流程" aria-label="一件事主题服务办理流程">
      <div class="graphic-section-title">流程<span class="em">更简单</span>，申办<span class="em">更轻松</span>，审批<span class="em">更快速</span></div>

      <div class="steps-container">
        <div class="graphic-section-small-title">
          <div class="start">办理流程</div>
          <div class="start-connect">
            <img src="../../../../assets/img/graphic/start-connect.svg" alt="">
          </div>
        </div>

        <div class="step-line" v-for="(steps, index) in stepItemList" :key="index">
          <div class="steps">
            <div class="step"  v-for="step in steps.itemList" :key="step.itemSeq">
              <div class="step-box">
                <div class="step-img-box" @mouseenter="showAcceptCondition(step, 1)"  @mouseleave="showAcceptCondition(step, 0)">
                  <img v-if="step.picPath" :src="`/ApprUnionInterface/api/attachfile/download.v?openOnline=true&stream=true&attachPath=${step.picPath}`" @error="handleImageError" title="图标：申办流程" alt="图标：申办流程">
                  <img v-else src="../../../../assets/img/graphic/step-default.svg"  title="图标：申办流程" alt="图标：申办流程">

                  <div class="accept-condition" v-if="step.showCondition == 1">
                    <div class="em">受理条件：</div>
                    <div>{{step.acceptCondition || '-'}}</div>
                  </div>
                </div>

                <div class="step-name ellipsis-more" :title="step.itemName">{{ step.itemName }}</div>
              </div>
            </div>
          </div>

          <div class="step-limit">办理时限 : <span class="em">{{ steps.limit }}</span> 工作日</div>
          <div class="step-connect" v-if="index+1 !== stepItemList.length">
            <img src="../../../../assets/img/graphic/step-connect.svg" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="graphic-material" wzades="一件事主题服务材料提交清单" aria-label="一件事主题服务材料提交清单">
      <div class="graphic-section-title">提交<span class="em">一次材料</span>，填写<span class="em">一份表单</span>，省心更省力</div>

      <div class="graphic-section-small-title">
        <div class="start">必须材料</div>
        <div class="start-connect">
          <img src="../../../../assets/img/graphic/start-connect.svg" alt="">
        </div>
      </div>

      <el-row class="material-list-box" :gutter="35" v-if="materials.length">
        <el-col class="material-col" v-for="(material, index) in materials" :span="12" style="position: relative" @mouseleave.native="showMaterialTips(material, 0)">
          <span class="material-index">{{index + 1}}</span>
          <span class="material-name">
            <span class="name common-ellipsis" :title="material.stuffName">{{material.stuffName}}</span>
            <span class="el-icon-warning-outline" tabindex="0" @keyup.tab="showMaterialTips(material, 1)" v-if="material.channelName || material.sourceChannel" @mouseenter="showMaterialTips(material, 1)"  @blur="showMaterialTips(material, 0)">
              <div class="material-name-tips" v-if="material.showTips == 1">
                <div class="em">渠道来源：</div>
                <div style="margin-bottom: 15px;">
                  渠道名称：{{ material.channelName || '-' }}<span v-if="material.sourceChannel == 99">，<span class="btn" @click="goOtherApply(material.channelLink)">点击查看</span></span>
                </div>

                <div class="em">填报须知</div>
                <div>{{material.fillExplain || '-'}}</div>
            </div>
            </span>

          </span>
        </el-col>
      </el-row>
      <div class="material-list-box" style="text-align: center" v-else>
        暂无必须提交的材料
      </div>
    </div>

    <div class="graphic-result" wzades="一件事主题服务获取的审批结果" aria-label="一件事主题服务获取的审批结果">
      <div class="graphic-section-title">一次领足“大礼包”，所需<span class="em">证件一步到位</span></div>

      <el-carousel class="graphic-result__carousel" trigger="click" arrow="always" :loop="false" :autoplay="false">
        <el-carousel-item style="text-align: center" v-for="(materials, index) in resultMaterials" :key="index">
          <div class="graphic-result-carousel-item" v-for="(material, _index) in materials" :key="`${index}_${_index}`" >
            <div class="img-box">
              <img v-if="material.materialPath" :src="`/ApprUnionInterface/api/attachfile/download.v?openOnline=true&stream=true&attachPath=${material.materialPath}`" title="图片：结果材料" alt="图片：结果材料">
              <img v-else src="../../../../assets/img/graphic/result-material-default.png" title="图片：结果材料" alt="图片：结果材料">
            </div>

            <div class="name ellipsis-more" :title="material.rsStuffName">{{ material.rsStuffName }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <side-float-btns @handleNow="handleNow"></side-float-btns>
  </div>

</template>

<script>
import defaultBanner from '../../../../assets/img/graphic/banner.svg'
import Banner from '@/components/Banner'
import SideFloatBtns from '@/components/SideFloatBtns'
import {doSaveSnapshot,loadTypeRsStuffListByTypeSeq, loadPictureStepItemList, loadTypeStuffListByTypeSeq, baseInfo, getAreaInfo} from "../../../../utils/indexUrl";
import {loadSSInfo} from "../../../../utils/jointApplyUrl";
import stepDefaultImg from '@/assets/img/graphic/step-default.svg'
import {buriedPointFunc} from "../../../../assets/utils/buriedPoint";
export default {
  name: "index",
  data() {
    return {
      baseInfo: JSON.parse(sessionStorage.getItem('baseInfo')),
      resultMaterialsLength: 0,
      bannerPic: defaultBanner, // 默认banner图
      materials: [],
      resultMaterials: [],
      stepItemList: []
    }
  },
  components: {Banner, SideFloatBtns},
  methods: {
    //获取地区信息
		async loadAreaInfo(jcAreaSeq) {
			getAreaInfo({
				jcAreaSeq,
				auditType: "internal"
			}).then(res => {
				if (+res.status === 200 && res.data) {
					this.$store.commit('setChosenAreaInfo', res.data)
          sessionStorage.setItem('chosenAreaInfo', JSON.stringify(res.data))
				} else {
					this.$message.warning('地区参数无效')
				}
			}).catch(err => {
				console.log('错误func--->', err);
			})
    },
    // 获取基本信息
    async getBaseInfo(typeSeq, jcAreaSeq) {
      try {
        let res = await baseInfo({
          jcAreaSeq,
          typeSeq
        })
        if (+res.status === 200) {
          sessionStorage.setItem('baseInfo', JSON.stringify(res.data))
          this.baseInfo = res.data
        } else {
          this.$message.error(res.desc || '获取基本信息失败')
        }
      } catch (err) {
        console.log(err)
        this.$message.error('获取基本信息失败')
      }
    },
    goOtherApply(url) {
      url.indexOf('http') < 0 ? window.open('http://' + url) :  window.open(url)
    },
    showMaterialTips(material, visible){
      this.$set(material, 'showTips', visible)
    },
    showAcceptCondition(step, visible){
      this.$set(step, 'showCondition', visible)
    },
    handleImageError(event) {
      event.target.src = stepDefaultImg
    },
    // 获取结果材料列表
    _loadTypeRsStuffListByTypeSeq() {
      loadTypeRsStuffListByTypeSeq({
        typeSeq: this.baseInfo.typeSeq
      }).then(res => {
        if (+res.status === 200) {
          this.resultMaterialsLength = res.data.length
          for(let i = 0; i < res.data.length ; i = (i+1)*4) {
            this.resultMaterials.push(res.data.slice(i, i+4))
          }
        } else {
          this.$message.error(res.desc || '获取结果材料列表失败！')
        }
      })
    },
    // 获取办理流程
    _loadPictureStepItemList() {
      loadPictureStepItemList({
        typeSeq: this.baseInfo.typeSeq
      }).then(res => {
        if (+res.status === 200) {
          this.stepItemList = res.data.itemPicture
        } else {
          this.$message.error(res.desc || '根据主题流水号获取服务流程步骤事项数据失败！')
        }
      })
    },
    // 获取必须材料
    _loadTypeStuffListByTypeSeq() {
      loadTypeStuffListByTypeSeq({
        typeSeq: this.baseInfo.typeSeq,
        needFlag: 1
      }).then(res => {
        if (+res.status === 200) {
          this.materials = res.data
        } else {
          this.$message.error(res.desc || '获取必须材料列表失败！')
        }
      })
    },
    async handleNow () {
      // 选择主题后清空unionControlSeq，避免上次办件影响
      sessionStorage.setItem("unionControlSeq", '');
      if (this.baseInfo.dealinfoEnable) {
        this.$router.push('/handlingInstructions')
      } else {
        this.goNair()
      }
    },
    async goNair() {
      // if (this.baseInfo.surveyEnable || this.baseInfo.surveyAddEnable == 1) {
      //   this.$router.push('/questionNair')
      // } else {
      //   // 没有问卷直接生成主题快照编号，去到导办指南页面
      //   await this._doSaveSnapshot()
      //   this.$router.push('/serviceDetails?isGuidance=1')
      // }

      this.$router.push('/questionNair')
    },
    async _doSaveSnapshot() {
      try{
        let res = await doSaveSnapshot({
          typeSeq: this.baseInfo.typeSeq,
          handleType: '1' // 办理模式（1：直接办理，2：前期辅导，3：智能引导）
        });
        if (+res.status === 200 || (+res.status === 400 && res.data)) {
          if (+res.status === 200) {
            await this._loadSSInfo(res.data.typeSnapshotSeq)
          }
        } else {
          this.$message.error(res.desc)
        }
      }catch(err) {
        this.$message.error(err)
      }

    },
    async _loadSSInfo(typeSnapSeq) {
      if (!typeSnapSeq) {
        return false
      }
      try {
        let res = await loadSSInfo({
          bizTypeSSSeq: typeSnapSeq
        })
        if (+res.status === 200) {
          sessionStorage.setItem('sSInfo', JSON.stringify(res.data))
        } else {
          this.$message.error(res.desc || '获取主题快照信息失败')
        }
      } catch (err) {
        this.$message.error(err)
      }
    },
    //返回上一页
    goBack(){
      this.$router.go(-1)
    }
  },
  async created() {
    let typeSeq = this.$route.query.typeSeq
    let jcAreaSeq = this.$route.query.jcAreaSeq
    if (jcAreaSeq && !sessionStorage.getItem('chosenAreaInfo')) {
      this.loadAreaInfo(jcAreaSeq)
    }
    if (typeSeq && jcAreaSeq && (!this.baseInfo || this.baseInfo.typeSeq != typeSeq)) {
      await this.getBaseInfo(typeSeq, jcAreaSeq)
    }
    if (!this.baseInfo) {
      this.$message.error('获取基本信息失败')
      return false
    }

    this._loadTypeRsStuffListByTypeSeq()
    this._loadPictureStepItemList()
    this._loadTypeStuffListByTypeSeq()
  },
  mounted() {
    // 进行埋点，记录页面事件
    let obj = {
      title:document.title || "", //页面名称
      actionId:"YjsImageText", //事件ID
      account:"ThemeItem", //系统标识
    }
    buriedPointFunc(obj)
  }
}
</script>

<style lang="scss" scoped>
.graphic-instructions {
  .banner-title {
    .title{
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0D1C28;
      line-height: 56px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 20px;
    }
    .tag{
      display: inline-block;
      vertical-align: middle;
      width: 117px;
      height: 37px;
      background: #4391F4;
      border-radius: 8px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 37px;
      text-align: center;
    }
    .banner-subtitle {
      margin-top: 10px;
      margin-bottom: 40px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0E478F;
      line-height: 25px;
      .subtitle:first-child{
        margin-bottom: 6px;
        .em{
          color: #2267BD;
          font-size: 20px;
        }
      }
      .subtitle:last-child{
        color: #2B7ADE;
        .em{
          color: #4391F4;
          font-size: 20px;
        }
      }
    }
  }

  .graphic-section-title{
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0D1C28;
    line-height: 56px;
    margin: 70px 0;
    .em{
      color: #4391F4;
    }
  }
  .graphic-section-small-title{
    .start{
      border-radius: 22px;
      border: 2px solid #4391F4;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4391F4;
      line-height: 33px;
      padding: 5px 35px;
      display: inline-block;
    }
    .start-connect{
      margin: 10px 0 20px;
    }
  }

  .graphic-steps{
    text-align: center;
    margin-bottom: 76px;
    .steps-container{
      .step-line{
        width: 1105px;
        margin: 0 auto;
        .step{
          display: inline-block;
          margin-bottom: 26px;
          .step-box{
            display: inline-block;
            vertical-align: middle;
            width: 144px;
            padding: 0 38px;
            .step-img-box{
              width: 100px;
              height: 100px;
              line-height: 100px;
              margin: 0 auto 4px;
              position: relative;

              .accept-condition{
                position: absolute;
                width: 400px;
                background: #FFF4D9;
                border-radius: 4px;
                bottom: 100px;
                right: -150px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 22px;
                padding: 12px;
                text-align:left;
                .em{
                  font-weight: bold;
                }
              }
            }
            img{
              width: 100%;
            }
            .step-name{
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #0D1C28;
              line-height: 22px;
              height: 44px;
            }
          }
        }
        .step::after{
          content: '';
          width: 0;
          height: 73px;
          display: inline-block;
          vertical-align: middle;
          border-right: 1px solid rgba(67,145,244,0.3000);
        }
        .step:nth-of-type(5n)::after, .step:last-child::after{
          height: 0;
        }
        .step-limit{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #45484B;
          line-height: 22px;
          margin-bottom: 20px;
          .em{
            font-size: 20px;
          }
        }
      }
    }
  }

  .graphic-material{
    text-align: center;
    background: #EEF9FF;
    overflow: hidden;
    padding: 20px 0 90px;
    .material-list-box{
      width: 900px;
      padding: 15px;
      display:inline-block;
      text-align: left;
      border-radius: 10px;
      border: 2px solid transparent;
      background: linear-gradient(#fafdff,#fafdff) padding-box,
      repeating-linear-gradient(-45deg,#c7defc 0, #c7defc 0.5em,#fafdff 0,#fafdff 0.75em);
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      .material-col{
        height: 25px;
        line-height: 25px;
        margin-top: 10px;
        margin-bottom: 10px;
        .material-index{
          color: #fff;
          background: #4391F4;
          width: 25px;
          height: 25px;
          float: left;
          text-align: center;
          border-radius: 50%;
          margin-right: 12px;
          display: inline-block;
          vertical-align: middle;
        }
        .material-name{
          color: #4391F4;
          width:calc(100% - 37px);
          display: inline-block;
          vertical-align: middle;
          .name{
            max-width: calc(100% - 28px);
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
          .el-icon-warning-outline{
            display: inline-block;
            vertical-align: middle;
          }
          .material-name-tips{
            position: absolute;
            width: 400px;
            background: #FFF4D9;
            border-radius: 4px;
            bottom: 25px;
            right: 0;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            padding: 12px;
            .em{
              font-weight: bold;
            }
            .btn{
              color: #4391F4;
              cursor: pointer;
            }
          }
        }
      }


    }
  }

  .graphic-result{
    text-align: center;

    .graphic-result__carousel{
      width: 1120px;
      margin: 0 auto 70px;
      .graphic-result-carousel-item{
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        width: 186px;
        padding: 7px 7px 0;
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.3000);
        margin: 5px 40px 5px 0;
        .img-box{
          width: 100%;
          height: 130px;
          line-height: 130px;
          overflow: hidden;
        }
        img{
          width: 100%;
          position: relative;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .name{
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #0D1C28;
          line-height: 22px;
          height:44px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
      .graphic-result-carousel-item:last-child{
        margin-right: 0;
      }

      /deep/.el-carousel__container{
        height: 220px;
      }
      /deep/.el-carousel__arrow{
        width: 60px;
        height: 60px;
        background: #FFFFFF;
        box-shadow: 2px 2px 10px 2px rgba(0,0,0,0.0500),-2px -2px 10px 2px rgba(0,0,0,0.0500);
        i{
          font-weight: bold;
          font-size: 24px;
          color: #4793F4;
        }
      }
      /deep/.el-carousel__arrow:hover{

        background: #4391f4;
        i{
          color: #FFFFFF;
        }
      }

      /deep/.el-carousel__arrow--right{
        right: 5px;
      }
      /deep/.el-carousel__arrow--left{
        left: 5px;
      }
    }
  }
}
</style>
